import React, {useCallback, useEffect, useRef, useState} from "react";
import AnimatedPage from "../../animations/AnimatedPage";
import classes from "./archive.module.css";
import {deleteContent, getArchiveV2} from "../../clients/ArchiveApiClient";
import ArchiveContent from "../../components/archive/ArchiveContent";
import PaginationComponent from "../../components/pagination/Paginators";
import {ArchiveSelect, defaultArchiveSelectValue} from "../../components/archive/ArchiveSelects";
import CreateButton from "../../components/buttons/CreateButton";
import {useAuth} from "../../context/AuthContext";
import {ArchiveContext} from "../../context/ArchiveContext";
import CreateArchiveContentForm from "../../components/forms/CreateArchiveContentForm";
import ConfirmDialog from "../../components/forms/ConfirmDialog";
import EditArchiveContentForm from "../../components/forms/EditArchiveContentForm";
import sendSuccessAlert, {sendErrorAlert} from "../../services/alertService";
import ContentSwitcher from "../../components/archive/ContentSwticher";

const Archive = () => {

    const [archive, setArchive] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [countElements, setCountElements] = useState(0);
    const size = 24;
    const [category, setCategory] = useState(defaultArchiveSelectValue);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [redactedArchive, setRedactedArchive] = useState(null);
    const [isRedacted, setIsRedacted] = useState(false);
    const [content, setContent] = useState('PHOTO');
    const {isUserAdmin} = useAuth();
    const firstLoadRef = useRef(true);

    function open() {
        setIsOpenCreate(true);
    }

    const handlePageClick = (event) => {
        setPage(event.selected);
    };

    const handleSelectChange = (selectedOption) => {
        setCategory(selectedOption);
    }

    const refresh = useCallback(async () => {
        try {
            const res = await getArchiveV2(page, size, category.value, content);
            if (res && res.data) {
                setCountElements(res.data.count_items);
                setArchive(res.data.items);
            } else {
                setCountElements(0);
                setArchive([]);
            }
        } catch (e) {
            console.error("Ошибка при загрузке архива:", e);
            setCountElements(0);
            setArchive([]);
        } finally {
            setLoading(false);
        }
    }, [page, size, category, content]);

    useEffect(() => {
        let cancelled = false;
        const fetchData = async () => {
            // полноэкранный лоадер только при первой загрузке;
            // смена Фото/Видео/категории/страницы обновляет данные «тихо»
            if (firstLoadRef.current) setLoading(true);
            try {
                const res = await getArchiveV2(page, size, category.value, content);
                if (cancelled) return;
                if (res && res.data) {
                    setCountElements(res.data.count_items);
                    setArchive(res.data.items);
                } else {
                    setCountElements(0);
                    setArchive([]);
                }
            } catch (e) {
                if (cancelled) return;
                console.error("Ошибка при загрузке архива:", e);
                setCountElements(0);
                setArchive([]);
            } finally {
                if (!cancelled) {
                    setLoading(false);
                    firstLoadRef.current = false;
                }
            }
        };

        fetchData();
        return () => {
            cancelled = true;
        };
    }, [page, category, content]);

    async function handleDelete() {
        const id = redactedArchive?.id;
        setDeleteModalOpen(false);
        setRedactedArchive(null);
        try {
            await deleteContent(id);
            sendSuccessAlert('Контент успешно удалён');
            await refresh();
        } catch (e) {
            console.error('Ошибка удаления контента:', e);
            sendErrorAlert('Не удалось удалить контент. Попробуйте ещё раз.');
        }
    }



    return (
        <ArchiveContext.Provider
            value={{
                isOpenCreate,
                setIsOpenCreate,
                setDeleteModalOpen,
                refresh,
                redactedArchive,
                setRedactedArchive,
                isRedacted, setIsRedacted
            }}>
            <div className={`container ${classes.wrapper}`}>
                <h2 className="p-3">Архив церкви</h2>

                {/* Контролы рендерятся один раз — не перемонтируются при смене Фото/Видео */}
                {isUserAdmin && (
                    <CreateButton text={'Добавить контент'} onClick={open}/>
                )}
                <h5 className={`text-center pt-3`}>Выберите категорию</h5>
                <ArchiveSelect value={category} handleChange={handleSelectChange}/>
                <ContentSwitcher value={content} onChange={setContent}/>
                <CreateArchiveContentForm/>
                <EditArchiveContentForm/>
                <ConfirmDialog
                    text={'Вы действительно хотите удалить контент?'}
                    isOpen={deleteModalOpen}
                    onClose={() => setDeleteModalOpen(false)}
                    onSubmit={handleDelete}
                />

                {loading ? (
                    <AnimatedPage/>
                ) : archive.length === 0 ? (
                    <div className="py-5">
                        <h3 className="text-center">Список пуст</h3>
                    </div>
                ) : (
                    <div className="container-fluid py-3">
                        <div className="row p-1">
                            {archive.map(el => (
                                <ArchiveContent el={el} key={el.id}/>
                            ))}
                        </div>

                        {Math.ceil(countElements / size) === 1 ? null :
                            <PaginationComponent size={size}
                                                 handlePageClick={handlePageClick}
                                                 countElements={countElements}
                                                 page={page}/>
                        }
                    </div>
                )}
            </div>
        </ArchiveContext.Provider>
    );
};

export default Archive;
